import { types } from 'mobx-state-tree'
import Router from 'next/router'
import TRACKING_EVENTS from '~/services/tracking'

export const RouterStore = types
  .model('RouterStore', {
    route: types.maybeNull(types.string),
    pathname: types.maybeNull(types.string),
    asPath: types.maybeNull(types.string),
    query: types.frozen({})
  })
  .actions(self => ({
    startRouterWatch: () => {
      self.updateRouterValues()
      Router.events.on('routeChangeComplete', self.updateRouterValues)
      Router.events.on('beforeHistoryChange', self.updateRouterValues)
    },
    updateRouterValues() {
      if (Router.route !== self.route) {
        self.route = Router.route
        TRACKING_EVENTS.general.pageView(self.route)
      }
      if (self.pathname !== Router.pathname) {
        self.pathname = Router.pathname
      }
      if (self.asPath !== Router.asPath) {
        self.asPath = Router.asPath
      }
      self.query = Router.query
    }
  }))
